import { Button, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import ExcelDownloadButton from '../MasterComponent/Button/ExcelDownloadButton';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../../store/index';
import { setSelectedMonth } from '../../store/monthSlice';

export interface HeaderProps<T extends string> {
  tabs?: T[];
  selectedTab?: T;
  onTabChange?: (tab: T) => void;
  onDownload?: () => void;
  isDownloading?: boolean;
  showMonthFilter?: boolean;
  showExcelDownload?: boolean;
}

const Header = <T extends string>({
  tabs,
  selectedTab,
  onTabChange,
  onDownload,
  isDownloading = false,
  showMonthFilter = true,
  showExcelDownload = true,
}: HeaderProps<T>): React.ReactElement => {
  const dispatch = useDispatch<AppDispatch>();
  const selectedMonth = useSelector((state: RootState) => state.month.selectedMonth);
  const monthOptions = useSelector((state: RootState) => state.month.monthOptions);
  const monthValue = selectedMonth || (monthOptions[0] ?? '');
  return (
    <div className="costBreakupHeaderRow">
      <div className="costBreakupTabs">
        {tabs && tabs.length > 0 && selectedTab && onTabChange && (
          <div className="tabs-show">
          {tabs.map((tab) => (
            <Button
              key={tab}
              className={`timeframeButton ${selectedTab === tab ? 'timeframeActive' : ''}`}
              onClick={() => onTabChange(tab)}
            >
              {tab}
            </Button>
          ))}
          </div>
        )}
      </div>
      {(showMonthFilter || showExcelDownload) && (
        <div className="costBreakupActions">
           {showMonthFilter && monthOptions.length > 0 && (
            <>
              <FormControl variant="outlined" size="small" className="month-dropdown-container">
                <InputLabel id="month-label" className="month-label">
                  Month
                </InputLabel>
                <Select
                  labelId="month-label"
                  id="month-select"
                  value={monthValue}
                  onChange={(e) => dispatch(setSelectedMonth(e.target.value))}
                  label="Select Month"
                  MenuProps={{
                    PaperProps: {
                      className: 'autocompletePaper',
                      style: {
                        minWidth: '136px',
                        maxWidth: 'max-content',
                        whiteSpace: 'nowrap',
                        background: 'white',
                      },
                    },
                  }}
                  className="selectDropdown month-filter"
                >
                  {monthOptions.map((month) => (
                    <MenuItem key={month} value={month}>
                      {month}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {showExcelDownload && onDownload && (
                <ExcelDownloadButton
                  onDownloadCsv={onDownload}
                  isExcelDownloading={isDownloading}
                />
              )}
          </>
          )}
        </div>
       )}
    </div>
  );
};

export default Header;
